"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Trigger = exports.Email = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _reactI18next = require("react-i18next");
var _ArrowDropDown = _interopRequireDefault(require("@material-ui/icons/ArrowDropDown"));
var _SendVia = _interopRequireDefault(require("../SendVia"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _VisibilityOff = _interopRequireDefault(require("@material-ui/icons/VisibilityOff"));
var _excluded = ["name", "email", "via"],
  _excluded2 = ["onClick"];
var Email = exports.Email = function Email(_ref) {
  var name = _ref.name,
    email = _ref.email,
    via = _ref.via,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("p", (0, _extends2["default"])({}, props, {
    className: "pb-1",
    style: {
      overflowWrap: 'break-word',
      wordBreak: 'break-word',
      hyphens: 'auto'
    }
  }), name && /*#__PURE__*/_react["default"].createElement("span", {
    className: "mr-2 text-primary"
  }, name), " ".concat(email), !!via && /*#__PURE__*/_react["default"].createElement(_SendVia["default"], {
    via: via
  }));
};
var Trigger = exports.Trigger = function Trigger(_ref2) {
  var onClick = _ref2.onClick,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: "Show Details"
  }, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: "flex items-center justify-center ml-1 cursor-pointer select-none hover:bg-secondary",
    onClick: onClick,
    style: {
      width: 16,
      height: 16
    }
  }, props), /*#__PURE__*/_react["default"].createElement(_ArrowDropDown["default"], null)));
};
var View = function View(_ref3) {
  var from = _ref3.from,
    to = _ref3.to,
    cc = _ref3.cc,
    bcc = _ref3.bcc,
    date = _ref3.date,
    replyTo = _ref3.replyTo,
    readReceiptBlocking = _ref3.readReceiptBlocking;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var items = [{
    label: 'From:',
    content: from
  }, {
    label: 'Reply To:',
    content: replyTo
  }, {
    label: 'To:',
    content: _react["default"].Children.count(to) > 0 ? to : null
  }, {
    label: 'CC:',
    content: _react["default"].Children.count(cc) > 0 ? cc : null
  }, {
    label: 'BCC:',
    content: _react["default"].Children.count(bcc) > 0 ? bcc : null
  }, {
    label: 'Date:',
    content: _moment["default"].unix(date).format('MMMM DD, YYYY, h:mm A')
  }, {
    label: /*#__PURE__*/_react["default"].createElement(_VisibilityOff["default"], {
      fontSize: "small"
    }),
    content: readReceiptBlocking ? t('message.readReceiptBlocking.tip') : null
  }];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-4 text-sm bg-card dark:bg-secondary",
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "px-4 overflow-y-scroll",
    style: {
      maxHeight: 250,
      width: 500
    }
  }, /*#__PURE__*/_react["default"].createElement("table", {
    className: "border-separate text-gray-light",
    style: {
      borderSpacing: 10
    }
  }, /*#__PURE__*/_react["default"].createElement("tbody", null, items.filter(function (_ref4) {
    var content = _ref4.content;
    return Boolean(content);
  }).map(function (_ref5, index) {
    var label = _ref5.label,
      content = _ref5.content;
    return /*#__PURE__*/_react["default"].createElement("tr", {
      key: index
    }, /*#__PURE__*/_react["default"].createElement("td", {
      className: "align-top whitespace-no-wrap opacity-50 font-semibold"
    }, label), /*#__PURE__*/_react["default"].createElement("td", {
      className: "w-full max-w-0"
    }, content));
  })))));
};
View.displayName = 'MessageDetailCard';
var _default = exports["default"] = View;
//# sourceMappingURL=index.js.map